var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-avatar',{attrs:{"size":_vm.size,"color":_vm.color},on:{"click":_vm.uploadAvatar}},[(!_vm.localAvatarUrl)?_c('span',{style:({'font-size': _vm.noImageTextFontSize, 'color': _vm.textColor})},[_vm._v(_vm._s(_vm.noImageText))]):_c('v-img',{attrs:{"src":_vm.localAvatarUrl}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }